<template>
  <nna-container>
    <div class="align-middle">    
      <h1 class="md-title">Recupero Password</h1>
      <!--<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>-->

      <form novalidate class="md-layout" @submit.prevent="onSubmitForm">

        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-20" v-show="showPrefix">
            <md-field>
              <label for="telephone">Telefono</label>
              <md-select v-model="form.prefix" name="prefix" id="prefix">
                <md-option value="+39">+39</md-option>
                <md-option value="+44">+44</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item">
            <md-field :class="getValidationClass('username')">
              <label for="username" v-show="showUsernameLabel">Telefono o email</label>
              <label for="username" v-show="showTelephone">Email</label>
              <md-input name="username" id="username" autocomplete="username" v-model="form.username" :disabled="sending" />
              <span class="md-error" v-if="!$v.form.username.required">Inserisci la tua username</span>
            </md-field>
          </div>
        </div>

        <md-button type="submit" class="md-raised md-primary" md-align="center">Recupera Password</md-button>
      </form>
    </div>
  </nna-container>  
</template>

<script>
import CMM from '@nonameapp-core'
import { mapActions } from 'vuex'
export default {
  name: 'VerifyNumber',
  mixins: [ 
    CMM._mixins.form("recoverPassword")
  ],
  data() {
    return {
      form: {
        username: null,
        prefix: '+39',
      },
      showTelephone: false,
      showEmail: false,
      showPrefix: false,
    }
  },
  computed: {
    showUsernameLabel() {
      return !this.showPrefix && !this.showTelephone
    },
  },
  watch: {
    'form.username': {
      handler(val){
        this.checkUserName(val)
      },
      deep: true
    }
  },  
  methods: {
    ...mapActions({
      resetPassword: "auth/resetPassword",
    }),
    onSubmitForm () {
      if(this.validateForm()) this.recover()
    },   
    checkUserName (val) {       
      const email = this.regex.email;
      const phone = this.regex.phone;
      if(email.test(String(val).toLowerCase())) {
        this.showTelephone = true        
        this.showPrefix = false
      }
      else if(phone.test(String(val).toLowerCase())) {
        this.showTelephone = false
        this.showPrefix = true        
      }
      else {
        this.showTelephone = false
        this.showPrefix = false
      }
    },    
    async recover() {
      this.sending = true
      try { 
        //this.form.username = this.showPrefix ? `${this.form.prefix}${this.form.username}` : this.form.username
        
        const phone = this.regex.phone;
        if(phone.test(String(this.form.username).toLowerCase())) this.form.username = `${this.form.prefix}${this.form.username}`

        const { data } = await this.resetPassword(this.form)
        if(data.hcode === "ok") {
          this.sending = false
          this.$router.push({ name: "auth.recover.sendcode", query: { username: this.form.username } })
          this.clearForm()
        } else {
          this.sending = false
          this.$toasted.show(data.msg, { type: 'error' })
        }        
     } catch (errors) {
       console.error("Error:", errors)
       this.sending = false
       this.$toasted.show('Qualcosa è andato storto!', { type: 'error' })
      }      
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/modules/auth/login/pages/RecoverPassword.vue